import { render, staticRenderFns } from "./ChartJS.vue?vue&type=template&id=4fdb33a8&lang=pug&"
import script from "./ChartJS.vue?vue&type=script&lang=ts&"
export * from "./ChartJS.vue?vue&type=script&lang=ts&"
import style0 from "./ChartJS.vue?vue&type=style&index=0&id=4fdb33a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports